import { DraggableOption } from "Bands/components/DraggableOption/DraggableOption";
import React from "react";
import { DragDropContext, Droppable, DropResult } from "react-beautiful-dnd";
import { Control, Controller, RegisterOptions } from "react-hook-form";
import { copy } from "shared/assets";
import { Card, FancyLink, Message } from "shared/components";
import { Spacer } from "shared/layout";
import { space } from "shared/styles/constants";
import { ICardTheme, IFormOption } from "shared/types";

import { FieldWrapper, FieldWrapperProps } from "../FieldWrapper";
import { StyledDraggableWrapper } from "./styles";

interface DraggableCheckboxGroupProps extends FieldWrapperProps {
  control: Control;
  validation?: RegisterOptions;
  onChange?: (value: any) => void;
  subText?: string;
  options: IFormOption[];
  setOptions?: (options: IFormOption[]) => void;
}

const { event: eventBlockCopy } = copy;

export const DraggableCheckboxGroup: React.FC<DraggableCheckboxGroupProps> = ({
  name,
  control,
  validation,
  error,
  onChange: triggerOnChange,
  subText,
  options,
  setOptions,
  ...rest
}) => {
  const reorder = (list: IFormOption[], startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const handleDragEnd = (result: DropResult) => {
    // dropped outside the list
    if (!result.destination || !options) {
      return;
    }

    const newList = reorder(options, result.source.index, result.destination.index);

    setOptions && setOptions(newList);
  };

  const handleSelectAll = (onChange: any) => {
    onChange(options.map(({ value }) => value));
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={validation}
      render={({ onChange, onBlur, value }) => (
        <FieldWrapper name={name} error={error} {...rest}>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="sideMenu">
              {provided => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  <Card theme={ICardTheme.secondary}>
                    <Spacer size="s" spaceDirection="horizontal" style={{ marginBottom: space.l }}>
                      <FancyLink to={"#"} onClick={() => handleSelectAll(onChange)}>
                        Select all
                      </FancyLink>
                      <FancyLink to={"#"} onClick={() => onChange(null)}>
                        Deselect all
                      </FancyLink>
                    </Spacer>
                    <StyledDraggableWrapper childrenLength={options.length}>
                      <Spacer size="m">
                        {options.length > 0 ? (
                          options.map((data, index) => (
                            <DraggableOption
                              {...{
                                data,
                                index,
                                name,
                                onChange,
                                onBlur,
                                value,
                                triggerOnChange,
                              }}
                            />
                          ))
                        ) : (
                          <Message>{eventBlockCopy.pdf.messages.noBlocksAdded}</Message>
                        )}
                      </Spacer>
                    </StyledDraggableWrapper>
                  </Card>
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </FieldWrapper>
      )}
    />
  );
};
